import {
  AppModule
} from './app/app.module';

// import {
//   enableProdMode
// } from '@angular/core';

import {
  platformBrowserDynamic
} from '@angular/platform-browser-dynamic';

// if (production) {
//   enableProdMode();
// } else {
//   /*
//   * For easier debugging in development mode, you can import the following file
//   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
//   *
//   * This import should be commented out in production mode because it will have a negative impact
//   * on performance if an error is thrown.
//   */
//   await import('zone.js/dist/zone-error');
// }

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch((err) => {
    // eslint-disable-next-line no-console
    return console.error(err);
  });
